module.exports = __webpack_public_path__ + "img/newland-banner.0a6846e3.png";